import MainLayout from '../../../../../Layout/MainLayout';
import AgentLiveTrackingMap from './AgentLiveTrackingMap';
import FeatureLocked from '../../../../../components/gating/FeatureLocked';
import { usePlanAccess } from '../../../../../components/gating/PlanGate';

const LiveTrackingMapPage = () => {
  const { isLocked } = usePlanAccess('pro');

  return (
    <MainLayout activeTab="tracking">
      <div className="relative p-4 md:p-8 space-y-6">
        <AgentLiveTrackingMap />
        {isLocked && <FeatureLocked featureKey="live-location" overlay={true} />}
      </div>
    </MainLayout>
  );
};

export default LiveTrackingMapPage;
